export default __webpack_public_path__ + "static/logo--full--white-gold-d40a2c65c135c8ec27ed4cb3688d38e5.svg";